import { createContext, useContext } from 'react';

export const NavBarContext = createContext({ isMobile: false });

export const useNavBarContext = () => useContext(NavBarContext);

export const NavBarProvider = NavBarContext.Provider;
